import * as ng from 'angular';

export const tinymceOptions = {
   debounce: true,
   theme: 'modern',
   plugins: 'link code paste',
   menubar: false,
   toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | code',
   inline: true,
   link_assume_external_targets: true,
   paste_as_text: true
};

ng.module('e360').constant('tinymceOptions', tinymceOptions);
